import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

const HeaderText = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontWeight: 'bold'
}));


export default function EnrollmentListColumnHeader() {
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const { t } = useTranslation();
    const tooltip = t('enroll_list_header_5_tooltip');

    return (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', backgroundColor: 'shadow.light' }}>
            <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', flex: '1 0 15%', pl: 2 }}>
                <Radio {...label} sx={{ fontSize: '16px', fontWeight: 'light', color: 'text.primary', ml: '8px' }} />
                <HeaderText>
                    {t('enroll_list_header_1')}
                </HeaderText>
            </Stack>
            <Box sx={{ ml: 0, flex: '1 0 10%' }}>
                <HeaderText sx={{ textAlign: 'left', pl: 3 }}>
                    {t('enroll_list_header_2')}
                </HeaderText>
            </Box>
            <Box sx={{ ml: 0, flex: '1 0 15%', alignItems: 'center' }}>
                <HeaderText>
                    {t('enroll_list_header_3')}
                </HeaderText>
            </Box>
            <Box sx={{ ml: 0, flex: '1 0 10%' }}>
                <HeaderText>
                    {t('enroll_list_header_4')}
                </HeaderText>
            </Box>
            <Stack direction='row' sx={{ ml: 0, flex: '1 0 10%', justifyContent: 'center' }} spacing={1}>
                <HeaderText>
                    {t('enroll_list_header_5')}
                </HeaderText>
                <Tooltip sx={{ maxWidth: 50 }} 
                    title={tooltip}>
                    <InfoIcon sx={{ color: 'info.main' }} />
                </Tooltip>
                

            </Stack>
            <Box sx={{ ml: 0, flex: '1 0 10%' }}>
                <HeaderText>
                    {t('enroll_list_header_6')}
                </HeaderText>
            </Box>
            <Box sx={{ ml: 0, flex: '1 0 10%' }}>
                <HeaderText>
                    {t('enroll_list_header_7')}
                </HeaderText>
            </Box>
            <Box sx={{ ml: 0, flex: '1 0 15%' }}>
                <HeaderText>
                    {t('enroll_list_header_8')}
                </HeaderText>
            </Box>
        </Stack>
    )

}
